import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { SidebarModulesComponent } from './components/sidebar/sidebar-modules/sidebar-modules.component';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from '../app-routing.module';
import { SearchComponent } from './components/header/search/search.component';
import { ServiciosEntidadesComponent } from './components/servicios-entidades/servicios-entidades.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent,
    SidebarModulesComponent,
    SearchComponent,
    ServiciosEntidadesComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    AppRoutingModule,
    SharedModule
  ],
  exports: [
    HeaderComponent,
    SidebarComponent,
    SidebarModulesComponent,
    ServiciosEntidadesComponent
  ],
})
export class CoreModule { }
